// based on: https://github.com/TNG/ngx-structurals/blob/master/projects/ngx-structurals/src/lib/ngx-alias/ngx-alias.directive.ts

import { Directive, Input, OnInit, Optional, TemplateRef, ViewContainerRef } from '@angular/core';

export class NgxLetContext<T> {
	public ngxLet: T = null!;
	public get $implicit(): T {
		return this.ngxLet;
	}
}

@Directive({
	selector: '[ngxLet]',
})
export class NgxLetDirective<T> implements OnInit {
	private readonly context = new NgxLetContext();

	constructor(private readonly viewContainer: ViewContainerRef, @Optional() private readonly templateRef: TemplateRef<unknown>) {
		if (!this.templateRef) {
			throw new Error(`[ngxLet] can only be used as a structural directive or on an ng-template.`);
		}
	}

	public static ngTemplateContextGuard<T>(dir: NgxLetDirective<T>, ctx: unknown): ctx is NgxLetContext<T> {
		return true;
	}

	public ngOnInit(): void {
		this.viewContainer.createEmbeddedView(this.templateRef, this.context);
	}

	@Input()
	public set ngxLet(expression: T) {
		this.context.ngxLet = expression;
	}
}
